import FormBuilder from '@components/common/FormBuilder';
import SingleSelectSearchDropdown from '@components/common/CustomSearchableDropdown/SingleSelectSearchDropdown';

function ReportsPopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    submitLoading,
    handleSubmit,
    editId,
    createdForOptions,
    createdFor,
    setCreatedFor,
  } = props;

  return (
    <div
      className={`compelte-task-wrapper create-report-popup-wrapper ${
        showUpdatePopup ? 'compelte-task-wrapper--active' : ''
      }`}
      style={{ width: '40%' }}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="compelte-task-wrapper__title">Expense Reports</h6>
        </div>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
        />
      </div>
      <div className="unassociated_main_container report-add-popup-container">
        {createdForOptions &&
          createdForOptions.length > 1 &&
          createdFor?.value !== 'self' && (
            <div className="form_wrapper-pipeline mb-3">
              <div className="form_builder_field">
                <SingleSelectSearchDropdown
                  label={'label'}
                  name="Submitting For"
                  lookup_api="users"
                  lookup_id={Number(
                    createdFor?.value !== 'self'
                      ? createdFor?.value
                      : createdForOptions.find(
                          (opt: any) => opt.value !== 'self',
                        )?.value,
                  )}
                  value={Number(
                    createdFor?.value !== 'self'
                      ? createdFor?.value
                      : createdForOptions.find(
                          (opt: any) => opt.value !== 'self',
                        )?.value,
                  )}
                  onChange={(val: any) => {
                    if (val && setCreatedFor) {
                      setCreatedFor({
                        value: String(val.id),
                        label: val.workflow_name || val.label,
                      });
                    }
                  }}
                  disabled
                  isSearchable={true}
                  showLabel
                />
              </div>
            </div>
          )}
        <FormBuilder
          fields={props.form}
          setFields={props.setForm}
          formOptions={props.formInfo}
          simpleValidator={props.simpleValidator}
        />
      </div>

      <div className="fixed_moda_footer_wrapper">
        <div style={{ marginRight: '20px' }}>
          <button
            className="ascent-button ascent-button--header-buttons ascent-button--primary "
            onClick={() => setShowUpdatePopup(false)}
          >
            Cancel
          </button>
          <button
            className="ascent-button ascent-button--header-buttons ascent-button--secondary ms-3"
            onClick={() => handleSubmit()}
            disabled={submitLoading}
          >
            {submitLoading ? 'Please wait...' : editId ? 'Update' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReportsPopup;
